import React from 'react';
import "../../styles/chats/send_image_dialog.css";

const SendImageDialog = ({image, isSendImageDialogShow, onDiscard, onSend}) => {
    return(
        <div className={`send_image_dialog ${isSendImageDialogShow ? "show" : ""}`}>
            <div className="send_image_dialog_overlay"></div>
            <div className="send_image_dialog_content">
                <img className="send_image_dialog_image" src={image} alt='Item' />
                <div className="send_image_dialog_buttons_container">
                    <div className="send_image_dialog_cancel_button" onClick={() => onDiscard(false)} >Discard</div>
                    <div className="send_image_dialog_button" onClick={onSend}>Send</div>
                </div>
            </div>
        </div>
    );
};

export default SendImageDialog;